import React from 'react'
import './simulate.css'
import {
  Box,
  Grid
} from '@mui/material'
import { FieldArray, Form, Formik } from 'formik'
import CustomInput from '../../leastcomponent/custominput/input'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import CustomButton from '../../leastcomponent/custombutton/custombutton'
import * as Yup from 'yup'
import CustomSelect from '../../leastcomponent/customselect/customselect'
import Plus from '../../assets/svg/Plus'

const StartTimeDelayedScenario = () => {
  const icon = <AiOutlineInfoCircle color="red" />
  const options = [
    { value: '1', label: 'Department1' },
    { value: '2', label: 'Department2' },
    { value: '3', label: 'Department3' },
    { value: '4', label: 'Department4' },
    { value: '5', label: 'Department5' },
    { value: '6', label: 'Department6' }
  ]
  const validationSchema = Yup.object().shape({
    parts: Yup.array().of(
      Yup.object().shape({
        objectType: Yup.string().required('Object Type is required'),
        specificObjectType: Yup.string().required('Specific object Type is required'),
        delay: Yup.string().required('Delay is required'),
        unit: Yup.string().required('Unit is required')

      })
    )
  })
  return (
        <Box className="form-wrapper">

            <Formik
                enableReinitialize={true}
                initialValues={{
                  tasks: [
                    {
                      objectType: '',
                      specificObjectType: '',
                      delay: '',
                      unit: ''
                    }
                  ]
                }}
                onSubmit={(values) => console.log('values======', values)}
                validationSchema={validationSchema}
            >
                {({
                  errors,
                  handleChange,
                  touched,
                  values,
                  setFieldValue
                }) => (
                    <React.Fragment>
                        <Form className="form-perent">
                            <Box className="form-child">
                                <FieldArray name="tasks">
                                    {({ push }) => (
                                        <React.Fragment>
                                            <Box className="gap-20">
                                                {values?.tasks?.length > 0 &&
                                                    values?.tasks?.map((tasks, index) => (
                                                        <Box key={index} >
                                                            <Box >
                                                                {/* To do fiture :
                                                                <Typography className="form-heading-1 pb-20">
                                                                    Task {index + 1}
                                                                    <span
                                                                        onClick={() => remove(index)}
                                                                        className="process-delete"
                                                                    >
                                                                        <DeleteIconNew />
                                                                    </span>
                                                                </Typography> */}
                                                                <Grid
                                                                    spacing={2}
                                                                    key={index}
                                                                    paddingBottom={'20px'}
                                                                    container
                                                                >
                                                                    <Grid item xs={12} md={6} xl={4}>
                                                                        <CustomSelect
                                                                            name={`tasks.${index}.objectType`}
                                                                            label="Select Object"
                                                                            placeholder="Select Type"
                                                                            className="default-select-new"
                                                                            options={options}
                                                                            value={values?.tasks?.[index]?.objectType}
                                                                            handleSelectChange={(e) =>
                                                                              setFieldValue(
                                                                                    `tasks.${index}.objectType`,
                                                                                    e?.target?.value
                                                                              )
                                                                            }
                                                                            errors={errors?.tasks?.[index]?.objectType}
                                                                            touched={
                                                                                touched?.tasks?.[index]?.objectType
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6} xl={4}>
                                                                        <CustomSelect
                                                                            name={`tasks.${index}.specificObjectType`}
                                                                            label="Select Specific Object"
                                                                            placeholder="Select Type"
                                                                            className="default-select-new"
                                                                            options={options}
                                                                            value={values?.tasks?.[index]?.specificObjectType}
                                                                            handleSelectChange={(e) =>
                                                                              setFieldValue(
                                                                                    `tasks.${index}.specificObjectType`,
                                                                                    e?.target?.value
                                                                              )
                                                                            }
                                                                            errors={errors?.tasks?.[index]?.specificObjectType}
                                                                            touched={
                                                                                touched?.tasks?.[index]?.specificObjectType
                                                                            }
                                                                        />

                                                                    </Grid>
                                                                    <Grid item xs={12} md={6} xl={4}>
                                                                        <CustomInput
                                                                            label="Delay"
                                                                            placeholder="Enter Delay"
                                                                            handleChange={handleChange}
                                                                            value={values?.tasks?.[index]?.delay}
                                                                            name={`tasks.${index}.delay`}
                                                                            InputProps={{
                                                                              endAdornment:
                                                                                    touched?.tasks?.[index]?.delay &&
                                                                                    errors?.tasks?.[index]?.delay &&
                                                                                    icon
                                                                            }}
                                                                            errors={errors?.tasks?.[index]?.delay}
                                                                            touched={touched?.tasks?.[index]?.delay}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid
                                                                    spacing={2}
                                                                    key={index}
                                                                    paddingBottom={'20px'}
                                                                    container
                                                                >
                                                                    <Grid item xs={12} md={6} xl={4}>
                                                                        <CustomSelect
                                                                            name={`tasks.${index}.unit`}
                                                                            label="Select unit"
                                                                            placeholder="Select hours/days"
                                                                            className="default-select-new"
                                                                            options={options}
                                                                            value={values?.tasks?.[index]?.unit}
                                                                            handleSelectChange={(e) =>
                                                                              setFieldValue(
                                                                                    `tasks.${index}.unit`,
                                                                                    e?.target?.value
                                                                              )
                                                                            }
                                                                            errors={errors?.tasks?.[index]?.unit}
                                                                            touched={
                                                                                touched?.tasks?.[index]?.unit
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Box>
                                                    ))}
                                            </Box>
                                            <Box paddingTop={'10px'}>
                                                {' '}
                                                <CustomButton
                                                    variant="outlined"
                                                    className="button-box"
                                                    type="button"
                                                    title="Add "
                                                    endIcon={<Plus fill={'#0160B9'} />}
                                                    onClick={() => push({
                                                      objectType: '',
                                                      specificObjectType: '',
                                                      delay: '',
                                                      unit: ''
                                                    })}

                                                />
                                            </Box>
                                        </React.Fragment>
                                    )}
                                </FieldArray>
                            </Box>
                        </Form>
                    </React.Fragment>
                )}
            </Formik>
        </Box>
  )
}

export default StartTimeDelayedScenario
